import { v3Url } from '@/utils/fetcher';
import { useAxios } from '../base/useAxios';

export default function useCommsAuthLoader() {
  const api = useAxios();

  return {
    fetchCommsAuthInfo() {
      return api.get(v3Url('comms/auth/info'));
    },
  };
}
